import React from "react";
import Lottie from "react-lottie";
import animationData from "../../lottie/loader.json";

const LoaderButton = ({ type, title, disabled, handleClick, style, name, className = '' }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <button
    name={name}
      onClick={handleClick}
      type={type}
      disabled={disabled}
      className={`${style} cta-one h-auto py-3 px-4 rounded-lg font-medium text-white bg-[#5A949A] hover:bg-[#4a7f85] transition-colors ${className} ${
        disabled ? "pointer-events-none cursor-not-allowed opacity-70" : ""
      }`}
    >
      {disabled ? (
        <Lottie options={defaultOptions} height={24} width={24} />
      ) : (
        // <img src={loadingGif} alt="loading..." className="mx-auto" width={24} height={24} />
        title
      )}
    </button>
  );
};

export default LoaderButton;